import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const Header = styled.div<{ $bottomBorder?: boolean }>`
  display: flex;
  align-items: center;
  min-height: 7.7rem;
  background-color: ${vars.colors.black};
  padding: 1.2rem 2rem 1.2rem 0.8rem;
  z-index: 9;
  cursor: default;
  margin-left: 2.8rem;
  margin-right: 2.8rem;
  position: relative; /* Needed for ::after positioning */

  ${({ $bottomBorder }) =>
    $bottomBorder &&
    css`
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, #3a3a3c 41.21%, #1c1c1e 100%);
      }
    `}

  > * {
    &:not(:last-child) {
      margin-right: 3.2rem;
    }
  }
`;
